<template>
    <form id="mainForm" action="#" method="post">
        <Card>
            <template #title>
                <Toolbar>
                    <template #left>
                        <div class="p-card-title">
                            {{ $t('localization') }}
                        </div>
                    </template>

                    <template #right>
                        <Button icon="pi pi-save" :label="$t('save')" class="p-button-success"
                            @click="confirm($event)" />
                        <ConfirmPopup></ConfirmPopup>
                    </template>
                </Toolbar>
            </template>
            <template #content>
                <div class="p-inputtext-sm p-fluid">

                    <div class="col-12">
                        <DataTable :loading="!this.header" :value="header ? header : null" v-if="header"
                            responsiveLayout="scroll" class="p-datatable-sm editable-cells-table" :rowClass="hideRow">
                            <Column>
                                <template #header="">
                                    <Button label="" icon="pi pi-plus" class="p-button-primary p-mr-2 p-button-sm"
                                        @click="addDetail" :disabled="false" />
                                </template>
                                <template #body="slotProps">
                                    <Button icon="pi pi-minus" class="p-button-danger p-mr-2 p-button-sm"
                                        @click="deleteDetail(slotProps)" :disabled="!canEdit" />
                                </template>
                            </Column>
                            <Column field="Code" :header="$t('code')">
                                <template #body="slotProps">
                                    <InputText name="Code" type="text" v-model="slotProps.data.Code"
                                        :disabled="slotProps.data.mode != $FORM_MODE_CREATE" :autoUppercase="false" />
                                </template>
                            </Column>
                            <Column v-for="(language, index) of languages" :key="language.Id"
                                :header="language.LookupValue">
                                <template #body="slotProps">
                                    <InputText type="text" v-model="slotProps.data.Details[index].Label"
                                        :autoUppercase="false" @change="editLocale(slotProps.data.Details[index])" />
                                </template>
                            </Column>


                        </DataTable>
                    </div>

                </div>
            </template>
        </Card>
    </form>
</template>


<script>
export default {
    name: "Index",
    data() {
        return {
            indexName: "LocalizationIndex",
            header: null,
            detail: null,
            mode: "Edit",
            id: 0,
            formEditable: true,
            dataModel: false,
            dataUrl: "localization/",
            listUrl: "localization/list",
        }
    },
    methods: {
        hideRow(data) {
            return data.mode == this.$FORM_MODE_DELETE ? 'row-hidden' : null;
        },
        getData() {
            var self = this;
            this.$axios.get(this.$API_URL + this.listUrl)
                .then((response) => {
                    self.header = response.data.data.header;
                    self.languages = response.data.data.languages;
                    self.detail = response.data.data.detail;
                    //self.header.mode = self.mode;
                })
                .catch(function (error) {
                    //alert(error);
                });
        },
        saveData() {
            var self = this;
            self.$emit('block-ui');
            this.$axios.post(this.$API_URL + this.dataUrl, this.header)
                .then((response) => {
                    if (response.data.success) {
                        self.$emit('unblock-ui');
                        self.$toast.add({ severity: 'success', summary: "Data Saved", detail: response.data.message, life: 120000 });
                        self.getData();
                        //this.$router.push({ name: this.indexName, params: { showToast: true, severity: 'success', summary: 'Data Saved', detail: response.data.message, life: 120000} } );
                    }
                    else {
                        self.showError('Error Saving Data', response.data.message);
                    }
                })
                .catch(function (error) {
                    this.showError('Error Saving Data', error);
                });
        },
        showError(summary, message) {
            this.$emit('unblock-ui');
            this.$toast.add({ severity: 'error', summary: summary, detail: message, life: 120000 });
        },
        toggle(event) {
            this.$refs.op.toggle(event);
        },
        confirm(event) {
            this.$confirm.require({
                target: event.currentTarget,
                message: 'Are you sure?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    this.saveData();
                },
                reject: () => {
                    //callback to execute when user rejects the action
                }
            });
        },
        addDetail() {
            var newDetail = this.detail;
            newDetail.mode = this.$FORM_MODE_CREATE;
            var det = { ...newDetail };

            this.header.push(det);
        },
        deleteDetail(event) {
            if (event) {
                var detail = this.header[event.index];

                if (detail.mode == this.$FORM_MODE_CREATE) this.header.splice(this.header.indexOf(detail), 1);
                else detail.mode = this.$FORM_MODE_DELETE;
            }
        },
        editDetail(index) {
            if (this.header.Details && this.header.Details.length > 0) {
                let m = this.header.Details[index].mode;

                if (m == this.$FORM_MODE_UNCHANGED) {
                    this.header.Details[index].mode = this.$FORM_MODE_EDIT;
                }
            }
        },
        editLocale(data) {
            let m = data.mode;

            if (m == this.$FORM_MODE_UNCHANGED) {
                data.mode = this.$FORM_MODE_EDIT;
            }
        }
    },
    created() {
        // this.mode = this.$route.query.mode;
        // this.id = this.$route.query.id ?? 0;

        this.getData();
    },
}
</script>